<template>
	<div>
		<winning-numbers-sidebar :open.sync="sidebarOpen" :results="externalLotteriesResults"></winning-numbers-sidebar>
		<v-btn id="external-results-btn" @click="sidebarOpen = !sidebarOpen" style="z-index: 4">
			Winning Numbers
		</v-btn>
		<v-row>
			<v-img contain height="200" :src="require('@/assets/img/leslycvip/logo.png')"></v-img>
		</v-row>
		<v-row justify="center">
			<v-col cols="auto">
				<v-btn id="see-it-live-btn" @click="scrollToStream">
					See it live
				</v-btn>
			</v-col>
		</v-row>
		<v-row justify="center" class="mb-5">
			<v-col
				xl="2"
				lg="4"
				md="4"
				sm="6"
				cols="12"
				v-for="(result, index) in results"
				:key="`${result.date}-${result.sortition.id}`"
			>
				<card class="result-card rounded-xl" :class="{'last-winning': index === 0}" :result="result"
							:pick-two-image="{ src: require('@/assets/img/leslycvip/pick_2.png'), width: '80px', height: '50px',contain: true }"
							:pick-three-image="{ src: require('@/assets/img/leslycvip/pick_3.png'), width: '80px', height: '50px',contain: true }"
							:pick-four-image="{ src: require('@/assets/img/leslycvip/pick_4.png'), width: '80px', height: '50px', contain: true }"
							:pick-five-image="{ src: require('@/assets/img/leslycvip/pick_5.png'), width: '80px', height: '50px', contain: true }"
				>
					<template #sortition-area="{date, sortition}">
						<v-row align="center">
							<v-col md="12">
								<h2 class="sortition-name">{{ sortition.name }}</h2>
								<h5 class="mb-0">
									{{ date }}
								</h5>
								<v-chip v-if="index === 0" color="success" class="font-weight-bold">Last Winning Numbers</v-chip>
							</v-col>
						</v-row>
					</template>
					<!--					<template v-if="index === 0" #header>-->
					<!--						<v-row justify="center">-->
					<!--							<v-col cols="auto">-->
					<!--								Last Winning-->
					<!--							</v-col>-->
					<!--						</v-row>-->
					<!--					</template>-->
				</card>
			</v-col>
		</v-row>

		<v-responsive :aspect-ratio="16 / 9">
			<iframe
				v-if="channelName && channelName.length > 0"
				id="frame"
				:src="
          `https://player.twitch.tv/?channel=${channelName}&parent=leslyc.tv`
        "
				frameborder="0"
				scrolling="no"
				allowfullscreen="true"
			>
			</iframe>
		</v-responsive>
	</div>
</template>

<script>
import BaseStream from "@homepage/components/pageStyles/BaseStream";
import {generateImageMapFor} from "@homepage/helpers/image";
import Card from "@homepage/components/streams/cards/Card.vue";

export default {
	name: "LeslycVipStream",
	components: {
		Card
	},
	extends: BaseStream,
	provide() {
		return {
			imagesMap: generateImageMapFor('quickmoney'),
		};
	},
};
</script>

<style scoped lang="scss">
@import './common.scss';

.result-card {
	color: white;
	box-shadow: 0 0 10px yellow, 0 0 20px black, 0 0 30px black !important;
	background-color: rgba(0, 0, 0, 0.5);
	backdrop-filter: blur(5px);
}

.sortition-name {
	word-break: keep-all;
}
</style>

<style>

#inspire {
	background-image: url("../../../assets/img/leslycvip/background.jpg");
	background-repeat: repeat-y !important;
	background-size: 100% 100%;
	background-attachment: fixed;
}
</style>
